import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Spinner } from "reactstrap";

import { AUTOPILOT_COLORS } from "../autopilot/styles";
import { acessoSftpAdminApi } from "./adminApi";

// "Mostrar senha" (PO1-2166): mascarada até o clique; cada clique é auditado no backend
// (evento SENHA_EXIBIDA); a senha some de novo sozinha (60 s no admin, 30 s no MeuFrete,
// via `ocultarMs`). Exibição e Copiar como no EmbarcadorTokenModal, só com tokens de cor.
// `api` troca as rotas (admin × MeuFrete), ver components/AcessoSftp/index.js.

const OCULTAR_MS = 60 * 1000;

const caixaStyle = {
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: "0.5rem",
  background: AUTOPILOT_COLORS.insetSurface,
  border: `1px solid ${AUTOPILOT_COLORS.border}`,
  borderRadius: 6,
  padding: "0.55rem 0.75rem",
  marginBottom: "0.6rem",
};

export default function MostrarSenha({ idEmbarcador, idTransportadora, api, ocultarMs }) {
  const cliente = api || acessoSftpAdminApi;
  const tempo = ocultarMs || OCULTAR_MS;
  const [senha, setSenha] = useState(null);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");
  const [copiado, setCopiado] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => { if (timer.current) clearTimeout(timer.current); }, []);

  const mostrar = useCallback(async () => {
    try {
      setLoading(true);
      setErro("");
      const r = await cliente.mostrarSenha(idEmbarcador, idTransportadora);
      setSenha(r.senha);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setSenha(null), tempo);
    } catch (e) {
      setErro(cliente.mensagemErro(e, "Não foi possível mostrar a senha."));
    } finally {
      setLoading(false);
    }
  }, [cliente, idEmbarcador, idTransportadora, tempo]);

  const copiar = useCallback(async () => {
    if (!senha) return;
    try {
      if (navigator.clipboard) {
        await navigator.clipboard.writeText(senha);
        setCopiado(true);
        setTimeout(() => setCopiado(false), 2000);
      }
    } catch (_) {
      // Clipboard bloqueada: o operador copia à mão.
    }
  }, [senha]);

  return (
    <div>
      <div style={caixaStyle}>
        <code style={{ fontSize: "0.9rem", color: AUTOPILOT_COLORS.title, letterSpacing: senha ? "0.02em" : "0.2em", flex: "1 1 10rem", wordBreak: "break-all" }}>
          {senha || "••••••••••••"}
        </code>
        {senha ? (
          <>
            <Button size="sm" color={copiado ? "success" : "secondary"} onClick={copiar} style={{ minWidth: 70 }}>
              {copiado ? "Copiado!" : "Copiar"}
            </Button>
            <Button size="sm" color="secondary" outline onClick={() => setSenha(null)}>
              Ocultar
            </Button>
          </>
        ) : (
          <Button size="sm" color="info" onClick={mostrar} disabled={loading}>
            {loading ? <Spinner size="sm" /> : "Mostrar senha"}
          </Button>
        )}
      </div>
      <div style={{ color: AUTOPILOT_COLORS.muted, fontSize: "0.74rem" }}>
        Cada exibição fica registrada (quem, quando). A senha some da tela em {Math.round(tempo / 1000)} s.
      </div>
      {erro ? <div style={{ color: AUTOPILOT_COLORS.statusDanger, fontSize: "0.8rem", marginTop: "0.3rem" }}>{erro}</div> : null}
    </div>
  );
}
